import { API } from 'aws-amplify';

export default class ExtensionClient {
  static deleteExtension(id: string) {
    return API.del('AppAPI', '/entities/dashboard', {
      body: [id],
    });
  }
}
